import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@components/buttons";
import { DateTime } from "luxon";
import { useRootAppStore } from "@hooks";
import { useFixBody } from "@state/hooks/shared";

export default function User24hLockPopup() {
	const { t } = useTranslation();
	const rootStore = useRootAppStore();

	useFixBody(true, rootStore.user24hLockStore.isActive);
	return (
		<div className="at-userLockPopUp popup">
			<div className="popup__card popup__card--sml">
				<HeaderLockPopupContent />

				<div className="popup__footer">
					<Button
						className="popup__footer__btn btn--base btn--accent"
						btnText={t("COMMON.OK_BTN")}
						onClick={rootStore.user24hLockStore.deactivatePopup}
					/>
				</div>
			</div>
		</div>
	);
}

function HeaderLockPopupContent() {
	const rootStore = useRootAppStore();
	const { t } = useTranslation();

	return rootStore.user24hLockStore.responseData &&
		rootStore.user24hLockStore.responseData.isSuccess ? (
		<>
			<div className="popup__header">
				<div className="popup__title">
					{t<string>("HEADER.24H_LOCK.POPUP_TITLE")}
				</div>
			</div>

			<div className="popup__body">
				<div className="card--icon u-mar--y--lrg">
					<i className="card--icon__icon card--icon__icon--danger u-icon u-icon--lrg u-icon--rounded u-icon--lock u-color--core--snow u-icon--animated--bounce-in" />
					<i className="card--icon__icon u-icon u-icon--huge u-icon--rounded u-icon--user" />
				</div>

				<div className="u-type--center">
					{rootStore.user24hLockStore.responseData.expirationDate
						? t<string>(
								"HEADER.24H_LOCK.24_HOURS_LOCK_SUCCESS_MESSAGE",
								{
									0: DateTime.fromISO(
										rootStore.user24hLockStore.responseData
											.expirationDate
									).toLocaleString(
										DateTime.DATETIME_SHORT_WITH_SECONDS
									),
									interpolation: {
										escapeValue: false,
									},
								}
							)
						: t<string>(
								"HEADER.24H_LOCK.24_HOURS_LOCK_SUCCESS_MESSAGE_WITHOUT_DATE"
							)}
				</div>
			</div>
		</>
	) : (
		<>
			<div className="popup__header">
				<div className="popup__title">
					{t<string>("HEADER.24H_LOCK.POPUP_TITLE")}
				</div>
			</div>

			<div className="popup__body">
				<div className="card--icon u-mar--y--lrg">
					<i className="card--icon__icon u-icon card--icon__icon--danger u-icon--lrg u-icon--rounded u-icon--alert-circle u-color--core--snow u-icon--animated--bounce-in" />
					<i className="card--icon__icon u-icon u-icon--huge u-icon--rounded u-icon--user" />
				</div>

				<div className="u-type--center">
					{t<string>("HEADER.24H_LOCK.LOCK_ERROR")}
				</div>
			</div>
		</>
	);
}
